import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "#000000",
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			height: 12,
			width: 2,
			x: 25,
			y: 26
		}),
		/* @__PURE__ */ _jsx("rect", {
			height: 12,
			width: 2,
			x: 31,
			y: 26
		}),
		/* @__PURE__ */ _jsx("rect", {
			height: 12,
			width: 2,
			x: 37,
			y: 26
		}),
		/* @__PURE__ */ _jsx("path", { d: "M50.79,9H48.93a10.16,10.16,0,0,0-7.31-3,11.2,11.2,0,0,0-1.55.11A12.54,12.54,0,0,0,31.67,3,12.73,12.73,0,0,0,24.2,5.38,8.22,8.22,0,0,0,21.73,5a7.68,7.68,0,0,0-6.87,4H13.21A3.12,3.12,0,0,0,10,12v2a2.93,2.93,0,0,0,1.14,2.28l5.35,41.44A3.82,3.82,0,0,0,20.3,61H43.7a3.82,3.82,0,0,0,3.81-3.28l5.35-41.44A2.93,2.93,0,0,0,54,14V12A3.12,3.12,0,0,0,50.79,9ZM21.73,7A6.28,6.28,0,0,1,24,7.43l.54.21L25,7.28a10.88,10.88,0,0,1,14.06.62l.38.36.51-.1A8.23,8.23,0,0,1,41.62,8a8.55,8.55,0,0,1,4.05,1H17.22A5.88,5.88,0,0,1,21.73,7ZM12,12a1.13,1.13,0,0,1,1.21-1H50.79A1.13,1.13,0,0,1,52,12v2a1.13,1.13,0,0,1-1.21,1H13.21A1.13,1.13,0,0,1,12,14ZM45.52,57.46A1.81,1.81,0,0,1,43.7,59H20.3a1.81,1.81,0,0,1-1.82-1.54L13.25,17h37.5Z" })
	]
});
export default SvgDelete;
